/* Awahe Academy — scroll reveal (fade-up). 5 Oct 2026.
   Pages opt in with data-aw-reveal on a wrapper; otherwise auto mode runs on
   the homepage, /pages/* and /collections/* (custom sections only).
   Content is only hidden after this script runs, so nothing is lost if JS fails.
   Respects prefers-reduced-motion. Classes: awsr, awsr-in, html.awsr-js. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var WRAP = /(^|\s)(aw-sp__band|aw-ty|aw-ca-why|aw-sp__split|awty-why|awty-why__l|aw-sp__prose|awsl|awsl__in|awsl__body|awsl__sec|awwh__col|awoff3)(\s|$)/;
  var LIST = /(^|\s)(aw-sp__facts|aw-sp__steps|aw-sp__grid|aw-sp__faq|aw-sp__weeks|awty-tiles|awty-reg|awty-perks|awty-eq|awsl__crs|awsl__cards|awsl__specs|awsl__steps|awsl__faq|awoff3__grid|aw-ca__regions|awfrx__cards)(\s|$)/;
  var SKIP = /^(SCRIPT|STYLE|LINK|NOSCRIPT|TEMPLATE|META|BR)$/;
  var SKIPCLS = /(^|\s)(aw-sp__hero|aw-sp__callbar|aw-sp__rule|awtrk)(\s|$)/;
  var LEAF = /^(P|H[1-6]|A|BUTTON|IMG|SVG|FIGURE|DETAILS|LI|TABLE|FORM|IFRAME|VIDEO)$/;
  /* other animation systems: Dawn (.scroll-trigger) and the homepage's legacy reveal (.aw-rv) */
  var OTHER = '.scroll-trigger,.aw-rv';

  function start() {
    var roots = [].slice.call(document.querySelectorAll('[data-aw-reveal]'));
    var auto = false;
    var path = location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '');
    if (!roots.length && (path === '/' || /^\/(pages|collections)(\/|$)/.test(path))) {
      roots = [].slice.call(document.querySelectorAll('#MainContent > .shopify-section'))
        .filter(function (s) { return !s.querySelector('.aw-rv'); });
      auto = true;
    }
    if (!roots.length) return;

    var targets = [];
    var vh = window.innerHeight || document.documentElement.clientHeight || 800;
    function add(el) { if (el && targets.indexOf(el) < 0) targets.push(el); }
    function cls(c) { return typeof c.className === 'string' ? c.className : ''; }
    function addList(c) { [].forEach.call(c.children, function (li) { if (!SKIP.test(li.tagName)) add(li); }); }

    function walk(el, depth) {
      [].forEach.call(el.children, function (c) {
        if (SKIP.test(c.tagName) || SKIPCLS.test(cls(c))) return;
        var pos = getComputedStyle(c).position;
        if (pos === 'fixed' || pos === 'sticky') return;
        if (LIST.test(cls(c))) return addList(c);
        if (WRAP.test(cls(c)) && depth < 4) return walk(c, depth + 1);
        add(c);
      });
    }
    function walkAuto(el, depth) {
      [].forEach.call(el.children, function (c) {
        if (SKIP.test(c.tagName) || SKIPCLS.test(cls(c))) return;
        var cs = getComputedStyle(c);
        if (cs.position === 'fixed' || cs.position === 'sticky' || cs.display === 'none') return;
        if (c.matches(OTHER)) { /* a tall Dawn block (whole page body) only animates once on load: reveal its parts */ if (!c.matches('.aw-rv') && depth < 7 && c.getBoundingClientRect().height > vh * 1.3) walkAuto(c, depth + 1); return; }
        if (c.querySelector(OTHER)) { if (depth < 7) walkAuto(c, depth + 1); return; }
        if (LIST.test(cls(c))) return addList(c);
        var h = c.getBoundingClientRect().height;
        var kids = [].filter.call(c.children, function (k) { return !SKIP.test(k.tagName); }).length;
        if (depth < 7 && kids >= 1 && (kids === 1 || h > vh * 1.1 || WRAP.test(cls(c))) && !LEAF.test(c.tagName)) return walkAuto(c, depth + 1);
        add(c);
      });
    }
    roots.forEach(function (r) { if (auto) walkAuto(r, 0); else walk(r, 0); });

    targets = targets.filter(function (el) {
      var b = el.getBoundingClientRect();
      return b.height > 0 && b.top > vh * 0.92; /* already on screen: leave as is */
    });
    if (!targets.length) return;

    document.documentElement.classList.add('awsr-js');
    targets.forEach(function (el) { el.classList.add('awsr'); });

    function done(el) { el.classList.remove('awsr', 'awsr-in'); }
    function show(el) { el.classList.add('awsr-in'); setTimeout(function () { done(el); }, 900); }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; io.unobserve(el);
        /* another script started animating inside it: step aside */
        if (el.querySelector(OTHER)) return done(el);
        show(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el) { io.observe(el); });

    /* anything skipped past (fast scroll, anchor jump) shows instantly, no fade */
    var tk = 0;
    window.addEventListener('scroll', function () {
      if (tk) return;
      tk = setTimeout(function () {
        tk = 0;
        targets.forEach(function (el) {
          if (el.classList.contains('awsr') && !el.classList.contains('awsr-in') && el.getBoundingClientRect().bottom < 0) { io.unobserve(el); done(el); }
        });
      }, 120);
    }, { passive: true });

    /* late-starting animations elsewhere (e.g. after load): step aside */
    function yieldOthers() { targets.forEach(function (el) { if (el.classList.contains('awsr') && el.querySelector(OTHER)) { io.unobserve(el); done(el); } }); }
    if (document.readyState === 'complete') setTimeout(yieldOthers, 50); else window.addEventListener('load', function () { setTimeout(yieldOthers, 50); });

    /* safety: never leave anything hidden */
    window.addEventListener('beforeprint', function () { targets.forEach(done); });
    setTimeout(function () {
      targets.forEach(function (el) { if (el.classList.contains('awsr') && el.getBoundingClientRect().top < (window.innerHeight || vh)) show(el); });
    }, 3000);
  }

  /* run after other page scripts have set up their own animations */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); });
  else setTimeout(start, 0);
})();
